<template>

    <div>

        <div class="row">
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-btn">
                        <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                    </span>
                    <input type="text" class="form-control" style="background: #e4e4e3" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                </div>
            </div> 
        </div>
        
        <div class="table-responsive">
            <table class="table table-bordered" style="width: 100%">
                <thead>
                    <tr class="bg-info text-center">
                        <th class="text-center" style="width: 5%; vertical-align: middle;">No.</th>
                        <th class="text-center" style="width: 10%; vertical-align: middle;">Kode Kantor</th>
                        <th class="text-center" style="width: 30%; vertical-align: middle;">NIP</th>
                        <th class="text-center" style="width: 10%; vertical-align: middle;">Kode Seksi</th>
                        <th class="text-center" style="width: 10%; vertical-align: middle;">Tgl Aktif</th>
                        <th class="text-center" style="width: 10%; vertical-align: middle;">Tgl NonAktif</th>
                        <th class="text-center" style="width: 10%; vertical-align: middle;">Kode Jabatan</th>
                        <th class="text-center" style="width: 15%; vertical-align: middle;">

                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                        <td class="text-center">{{index+1}}.</td>
                        <td class="text-center">{{data.kd_kantor}}</td>
                        <td>{{data.nip}}</td>
                        <td class="text-center">{{data.kd_seksi}}</td>
                        <td class="text-center">{{data.tgl_awal_berlaku}}</td>
                        <td class="text-center">{{data.tgl_akhir_berlaku}}</td>
                        <td class="text-center">{{data.kd_jabatan}}</td>
                        <td class="text-center" >
                            <button @click="getView(data._id, data.nm_seksi, data.no_srt_seksi, data.kode_surat_1, data.kode_surat_2)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                <i class="material-icons" >create</i>
                            </button>
                                &nbsp;
                            <button @click="removeData(data._id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                <i class="material-icons" >clear</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
                
            </table>
        </div>

        <hr>
            <div class="text-center">
                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                    <i class="material-icons">skip_previous</i>
                </button>

                <span style="font-size: 85%; color: #a5a5a5"><b>	&nbsp; {{page_first}} - {{page_last}} 	&nbsp;</b></span>

                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                    <i class="material-icons">skip_next</i>
                </button>
            </div>
        <hr>


    <!-- ============================================================ MODAL ======================================================================== -->


        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                        </div>
                        <div class="modal-body">

                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Kantor</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="nm_seksi" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">NIP</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="no_srt_seksi" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Seksi</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kd_seksi" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Tanggal Awal Berlaku</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="tgl_awal_berlaku" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Tanggal Akhir Berlaku</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="tgl_akhir_berlaku" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Jabatan</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kd_jabatan" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Wewenang</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kd_wewenang" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        </div>
                        <div class="modal-footer">
                            <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-green">
                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                        </div>
                        <div class="modal-body">

                            <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Nama Divisi</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="nm_seksi" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">No Surat Divisi</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="no_srt_seksi" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Surat 1</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kode_surat_1" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Surat 2</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kode_surat_2" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        </div>
                        <div class="modal-footer">
                            <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


    <!-- ============================================================ MODAL ======================================================================== -->

    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/bhumie_posisi_pegawai/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
      id : "",
      kd_kantor: "",
      nip: "",
      kd_seksi: "",
      tgl_awal_berlaku: "",
      tgl_akhir_berlaku: "",
      kd_wewenang: "",
      kd_jabatan: "",

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: ""


    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    addData : function(){
      fetch(ADD_URL+'add', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          nm_seksi : this.nm_seksi,
          no_srt_seksi : this.no_srt_seksi,
          kode_surat_1 : this.kode_surat_1,
          kode_surat_2 : this.kode_surat_2,
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses menambah data");
        this.getData();
      });
    },

    editData : function(){
      fetch(ADD_URL+'update', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token
        },
        body : JSON.stringify({
          id : this.id,
          nm_seksi : this.nm_seksi,
          no_srt_seksi : this.no_srt_seksi,
          kode_surat_1 : this.kode_surat_1,
          kode_surat_2 : this.kode_surat_2,
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses mengubah data");
        this.getData();
      })
    },

    removeData : function(id){
      fetch(ADD_URL+"remove", {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token,
        },
        body : JSON.stringify({
          id : id,
        })
      }).then(()=>{
        this.alertku("success", "sukses menghapus data");
        this.getData();
      })
    },

    getView : function(id, nm_seksi, no_srt_seksi, kode_surat_1, kode_surat_2){
      this.id = id;
      this.nm_seksi = nm_seksi;
      this.no_srt_seksi = no_srt_seksi;
      this.kode_surat_1 = kode_surat_1;
      this.kode_surat_2 = kode_surat_2;
    },



// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================

// ================== AUTOCOMPLETED ====================
    autocompleted : function(){

      $.ajax({
        url: URL_APP+'api/v1/kabupaten/',
        type: "GET",
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token,
        },
        success: function(result){

          horsey(document.querySelector('#kabupaten'), {
            source: [{ list: result }],
            getText: 'nm_dati2',
            getValue: 'nm_dati2',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="head_auto">`+suggestion.detilwilayah.nm_propinsi+`</span><br>
              <span class="body_auto">`+suggestion.nm_dati2+`</span>`
            },
            predictNextSearch(info) {
              document.getElementById('kabupaten_id').value= info.selection.kd_dati2 ;
            },
            limit: 2
          });

          horsey(document.querySelector('#e_kabupaten'), {
            source: [{ list: result }],
            getText: 'nm_dati2',
            getValue: 'nm_dati2',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="head_auto">`+suggestion.detilwilayah.nm_propinsi+`</span><br>
              <span class="body_auto">`+suggestion.nm_dati2+`</span>`
            },
            predictNextSearch(info) {
              document.getElementById('e_kabupaten_id').value= info.selection.kd_dati2 ;
            },
            limit: 2
          });

      }});

    },
// ================== AUTOCOMPLETED ====================

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
    // this.autocompleted();
  },
};
</script>
